// .env is converted to window.__config via Docker run.sh

type WindowWithConfigs = {
  __config: Record<string, string>
}

export const CONTENT_URL = (window as unknown as WindowWithConfigs).__config['FRECKLE_CONTENT_URL']
